exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".monitoring-card-link[data-v-463c4600]{display:block;text-decoration:none;color:inherit}.monitoring-card-link[data-v-463c4600]:hover{text-decoration:none}.monitoring-card[data-v-463c4600]{cursor:pointer;transition:transform .15s ease,box-shadow .15s ease;border:1px solid #ebedf2}.monitoring-card[data-v-463c4600]:hover{transform:translateY(-3px);box-shadow:0 .5rem 1rem rgba(0,0,0,.1);border-color:#5867dd}.monitoring-card-icon[data-v-463c4600]{padding-top:10px}.monitoring-card-title[data-v-463c4600]{font-weight:500;color:#48465b}.monitoring-card-desc[data-v-463c4600]{font-size:.9rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-463c4600","scoped":true,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./App/Components/BudgetPlan/BudgetPlanMonitoring.vue
// module id = 1079
// module chunks = 0